const ProgressBar = (props) => {
  let {
    size = 50,
    progress = 0,
    trackWidth = 10,
    trackColor = `#ddd`,
    indicatorWidth = 10,
    indicatorColor = `#b10e84`,
    indicatorCap = `round`,
    spinnerSpeed = 1,
    showPercent = false,
    style
  } = props;

  const center = size / 2,
    radius =
      center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth),
    dashArray = 2 * Math.PI * radius,
    dashOffset = dashArray * ((100 - progress) / 100);

  return (
    <>
      <div style={{ width: size, height: size, ...style }}>
        <svg className="svg-pi" style={{ width: size, height: size }}>
          <circle
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            stroke={trackColor}
            strokeWidth={trackWidth}
          />
          <circle
            style={{ animationDuration: spinnerSpeed * 1000 }}
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            stroke={indicatorColor}
            strokeWidth={indicatorWidth}
            strokeDasharray={dashArray}
            strokeDashoffset={dashOffset}
            strokeLinecap={indicatorCap}
          />
        </svg>
        {showPercent && (
          <span
            style={{ position: "absolute", top: "30px", left: "30px" }}
          >{`${progress}%`}</span>
        )}
      </div>
    </>
  );
};

export default ProgressBar;
